import { createContext, useContext, useLayoutEffect } from "react";
import { BotData } from "@shared/types";
export const OnboardingBotSetupContext = createContext<
  | {
      onCreated: (bot?: BotData) => void;
      /** Confirm mode: a short confirmation stands in for the form. */
      confirming?: boolean;
      /** Where the confirmation renders (outside the hidden form). */
      confirmSlot?: HTMLElement | null;
      /** Leaves confirm mode for the full form (values kept). */
      onCustomize?: () => void;
      /** The practice preset's values are all in (none to wait for: true). */
      presetReady?: boolean;
      /** Called by the practice preset once its values are all in. */
      onPresetReady?: () => void;
    }
  | undefined
>(undefined);

export const OnboardingCompletionContext = createContext({
  completed: false,
  setCompleted: (_completed: boolean) => {},
});
export const useOnboardingCompletion = () => {
  const { setCompleted } = useContext(OnboardingCompletionContext);
  useLayoutEffect(() => {
    setCompleted(true);
    return () => setCompleted(false);
  }, [setCompleted]);
};
